// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1kKat","header":"ClearentDisclaimer_header__1roCt","inner":"ClearentDisclaimer_inner__25sm7"};